import React, { useEffect, useState, useRef } from 'react';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import leftArrow from '../../../assets/SVGs/leftArrow.svg';
import './styles.css';
import {
	Typography,
	Box,
	Modal,
	Button,
	FormControlLabel,
	Checkbox,
	IconButton,
} from '@mui/material';
import { useStyles } from './styles';
import HierarchySelectorWrapper from './HierarchySelectorWrapper';
import SaveHierarchyModal from './SaveHierarchyModal';
import { useDispatch, useSelector } from 'react-redux';
import {
	saveHierarchyFilter,
	openHierarchy,
	saveHierarchy,
	setSelectedHierarchy as userSelectedHierarchy,
	setEditFlow,
	setEditHierarchy,
	editSavedHierarchy,
	validateHierarchy,
	resetValidateHierarchy,
	editSelectedHierarchy as modifySelectedHierarchy,
} from '../../../redux/actions/fullCompanyViewAction';
import { setSelectedUPC } from '../../../redux/actions/salesActions';
import { ThemeProvider } from '@mui/styles';
import { theme } from '../../../theme/theme';
import { UserPortalContext } from '../../../context/appcontext';
import CloseIcon from '@mui/icons-material/Close';
import SnackBarWrapper from '../../SnackBarWrapper/SnackBarWrapper';
import { colors } from '../../../theme/color-palette';
import {
	SAVE_HIERARCHY_ERROR_MESSAGE,
	SAVE_HIERARCHY_SUCCESS,
	SAVE_HIERARCHY_SUCCESS_DEFAULT,
	errorStatusSaveHierarchy,
	HIERARCHY_APPLIED_SUCCESSFULLY,
	MAIN_INSIGHTS_DASHBOARD
} from '../../../constants/constant';
import TextField from '@mui/material/TextField';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Alert from '../../Notifications/Alert.js';
import AlertIcon from '../../../assets/SVGs/errorIcon.svg';
import warningIcon from '../../../assets/SVGs/warningIcon.svg';
import { saveEventTrack } from '../../../redux/actions/eventTrackAction';
const { WARNING_HIGH, WARNING_MD, WARNING_MIN, WARNING_LIGHT } = colors;
import analytics from '../../../helper/analytics';
import tracker from '../../../constants/tracker';

function BusinessHierarchy() {
	const [modalOpen, setModalOpen] = useState(false);
	const [saveHierarchyOpen, setSaveHierarchyOpen] = useState(false);
	const [isSaveHierarchy, setIsSaveHierarchy] = useState(false);
	const [selectedHierarchy, setSelectedHierarchy] = useState([]);
	const [isSnackBarOpen, setIsSnackBarOpen] = useState(true);
	const [isDefault, setIsDefault] = useState(false);
	const [defaultStatus, setDefaultStatus] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [openInputBox, setOpenInputBox] = useState(false);
	const [errorMsg, setErrorMsg] = useState(null);
	const [hierarchySelections, setHierarchySelections] = useState([]);
	const [validationErrorMsg, setValidationErrorMsg] = useState(null);
	const [editSaveSnackBarOpen, setEditSaveHierarchyOpen] = useState(true);

	const textStyle = {
		fontFamily: 'Bogle',
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: '24px',
	};
	const [saveHierarchyPayload, setSaveHierarchyPayload] = useState({});

	const portalUserContext = React.useContext(UserPortalContext);

	const inputRef = useRef();

	const dispatch = useDispatch();
	const hierarchyFilterRhid = useSelector(
		(state) => state?.fullCompanyViewReducer?.hierarchyFilterRhid
	);
	const savedHierachy = useSelector(
		(state) => state?.fullCompanyViewReducer?.savedHierarchy
	);
	const openHierarchyModal = useSelector(
		(state) => state?.fullCompanyViewReducer?.hierarchyModalOpen
	);
	const saveHierarchyStatusCode = useSelector(
		(state) => state?.fullCompanyViewReducer?.saveHierarchyStatusCode
	);

	const isEditFlow = useSelector(
		(state) => state?.fullCompanyViewReducer?.isEditFlow
	);

	const editHierarchy = useSelector(
		(state) => state?.fullCompanyViewReducer?.editHierarchy
	);

	const validateHierarchyErrorMsg = useSelector(
		(state) => state?.fullCompanyViewReducer?.validateHierarchyErrorMsg
	);

	const validateHierarchyErrorMsgCode = useSelector(
		(state) => state?.fullCompanyViewReducer?.validateHierarchyErrorMsgCode
	);

	const validateHierarchyErrorCode = useSelector(
		(state) => state?.fullCompanyViewReducer?.validateHierarchyErrorCode
	);

	const editSavedHierarchyErrorCode = useSelector(
		(state) => state?.fullCompanyViewReducer?.editSavedHierarchyErrorCode
	);

	const editSavedHierarchyErrorMsg = useSelector(
		(state) => state?.fullCompanyViewReducer?.editSavedHierarchyErrorMsg
	);

	const editSelectedHierarchy = useSelector(
		(state) => state?.fullCompanyViewReducer?.editSelectedHierarchy
	);

	const validateHierarchyLoading = useSelector(
		(state) => state?.fullCompanyViewReducer?.validateHierarchyLoading
	);

	const checkEditHierarchyName = () => {
		if (searchText === '') {
			setErrorMsg(errorStatusSaveHierarchy.NO_NAME);
		} else if (searchText?.length > 255) {
			const text_exceeded =
				errorStatusSaveHierarchy.LENGTH_EXCEEDED +
				`(${searchText?.length}/255).`;
			setErrorMsg(text_exceeded);
		} else {
			savedHierachy?.map((hierarchy) => {
				if (hierarchy?.id !== editHierarchy?.id) {
					if (hierarchy?.name === searchText) {
						setErrorMsg(errorStatusSaveHierarchy.NAME_EXIST);
					}
				}
			});
		}
	};

	useEffect(() => {
		setModalOpen(openHierarchyModal);
		if (isEditFlow) {
			setErrorMsg(null);
			setDefaultStatus(editHierarchy?.isDefault);
			setSearchText(editHierarchy?.name);
			setEditSaveHierarchyOpen(true);
		}
	}, [openHierarchyModal]);

	useEffect(() => {
		if (validateHierarchyErrorCode == 400) {
			setIsSaveHierarchy(false);
		}
		if (editSavedHierarchyErrorCode == 400) {
			setValidationErrorMsg(editSavedHierarchyErrorMsg);
		}
	});

	useEffect(() => {
		if (editSavedHierarchyErrorCode == 200) {
			setModalOpen(false);
			dispatch(openHierarchy(false));
			dispatch(setEditFlow(false));
			dispatch(modifySelectedHierarchy(false));
			setErrorMsg(null);
		}
	}, [editSavedHierarchyErrorCode]);

	const classesName = useStyles();

	const handleModalClose = () => {
		setModalOpen(false);
		setIsSaveHierarchy(false);
		dispatch(openHierarchy(false));
		dispatch(setEditFlow(false));
		dispatch(setEditHierarchy(null));
		setOpenInputBox(false);
		setErrorMsg(null);
		dispatch(resetValidateHierarchy());
		setValidationErrorMsg(null);
		dispatch(modifySelectedHierarchy(false));
	};
	const handleApply = () => {
		dispatch(setSelectedUPC([]));
		let selectedHierarchyRhid = '';
		selectedHierarchy?.forEach((hierarchy) => {
			selectedHierarchyRhid += hierarchy?.nestedId + ',';
		});
		dispatch(saveHierarchyFilter(selectedHierarchyRhid?.slice(0, -1)));
		dispatch(
			userSelectedHierarchy({
				name: 'Custom',
				hierarchyFilterRhId: selectedHierarchyRhid?.slice(0, -1),
			})
		);

		setModalOpen(false);
		dispatch(openHierarchy(false));
		if (isSaveHierarchy) {
			setSaveHierarchyOpen(true);
		}
		setIsSaveHierarchy(false);
		dispatch(resetValidateHierarchy());
		setValidationErrorMsg(null);
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.CUSTOM_HIERARCHY,
		});
	};
	const handleOnCloseSaveHierarchy = () => {
		setSaveHierarchyOpen(false);
	};

	const handleSaveHierarchy = (isDefault, hierarchyName) => {
		const rhIds = selectedHierarchy?.map((hierarchy) => hierarchy?.nestedId);
		setSaveHierarchyPayload({
			portalUserContext,
			isDefault,
			request: {
				insightPreferences: [
					{
						name: hierarchyName,
						rhIds: rhIds,
					},
				],
			},
		});

		dispatch(
			saveHierarchy({
				portalUserContext,
				isDefault,
				request: {
					insightPreferences: [
						{
							name: hierarchyName,
							rhIds: rhIds,
						},
					],
				},
			})
		);

		const request = {
			event: 'SAVE',
			event_description: 'Save the preference for Hierarchy',
			attributes: MAIN_INSIGHTS_DASHBOARD,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));

		setIsDefault(isDefault);
		setSaveHierarchyOpen(false);
		setIsSaveHierarchy(false);
		setIsSnackBarOpen(true);
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.SAVE_HIERARCHY,
		});
	};

	const savedHierachyNames = savedHierachy?.map((item) => {
		if (item?.name && item?.name?.length !== 0) {
			return item.name;
		}
	});

	const handleSnackBarClose = () => {
		setIsSnackBarOpen(false);
	};

	const handleEditSaveSnackBar = () => {
		setEditSaveHierarchyOpen(false);
	};

	const changeSavedHierarchyDefaultStatus = (event) => {
		setDefaultStatus(event);
	};

	const handleSave = () => {
		const updatedRhIds = [];
		selectedHierarchy?.forEach((hierarchy) => {
			updatedRhIds.push(hierarchy?.nestedId);
		});
		const editedHierarchy = {
			...editHierarchy,
			name: searchText,
			rhIds: updatedRhIds,
			isDefault: defaultStatus,
		};
		const payload = {
			insightPreferences: [editedHierarchy],
		};
		dispatch(
			editSavedHierarchy({
				portalUserContext,
				request: payload,
				type: 'edit',
				editSelectedHierarchy: editSelectedHierarchy,
			})
		);
		setValidationErrorMsg(null);
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	});

	const handleClickOutside = (e) => {
		if (!inputRef?.current?.contains(e.target)) {
			setOpenInputBox(false);
		}
		checkEditHierarchyName();
	};

	const modifyInputText = () => {
		setErrorMsg(null);
		setOpenInputBox(true);
	};

	const handleTryAgain = () => {
		dispatch(saveHierarchy(saveHierarchyPayload));
	};

	const updateHierarchySelections = (hierarchySelections) => {
		setHierarchySelections(hierarchySelections);
		setIsSaveHierarchy(false);
		if (
			validateHierarchyErrorCode == 400 ||
			editSavedHierarchyErrorCode == 400
		) {
			dispatch(resetValidateHierarchy());
			setValidationErrorMsg(null);
		}
	};

	const action = (statusCode) => (
		<React.Fragment>
			{statusCode > 200 && (
				<Button className={classesName.tryAgainButton} onClick={handleTryAgain}>
					<Typography className={classesName.tryAgainText}>
						Try again
					</Typography>
				</Button>
			)}
			<IconButton
				size="small"
				aria-label="close"
				color="inherit"
				fontSize="14px"
				onClick={handleSnackBarClose}>
				<CloseIcon fontSize="small" />
			</IconButton>
		</React.Fragment>
	);

	const editSaveAction = (
		<React.Fragment>
			<IconButton
				size="small"
				aria-label="close"
				color="inherit"
				fontSize="14px"
				onClick={handleEditSaveSnackBar}>
				<CloseIcon fontSize="small" />
			</IconButton>
		</React.Fragment>
	);

	const checkHierarchy = (value) => {
		setIsSaveHierarchy(value);
		if (value) {
			const updatedRhIds = [];
			selectedHierarchy?.forEach((hierarchy) => {
				updatedRhIds?.push(hierarchy?.nestedId);
			});
			dispatch(
				validateHierarchy({
					portalUserContext,
					request: {
						insightPreferences: [
							{
								rhIds: updatedRhIds,
							},
						],
					},
				})
			);
		}
	};

	const closeValidateHierarchyErrorMsg = () => {
		dispatch(resetValidateHierarchy());
		setValidationErrorMsg(null);
	};

	const saveHierarchyMessageDefault = isDefault
		? SAVE_HIERARCHY_SUCCESS_DEFAULT
		: SAVE_HIERARCHY_SUCCESS;

	return (
		<ThemeProvider theme={theme}>
			<Box className={classesName.hierarchyFilter}>
				<Modal
					open={modalOpen}
					onClose={handleModalClose}
					aria-labelledby="parent-modal-title"
					aria-describedby="parent-modal-description"
					slotProps={{
						backdrop: {
							style: { backgroundColor: 'rgba(255, 255, 255, 0.7)' },
						},
					}}>
					<Box className={classesName.modalBox}>
						<Box className={classesName.backButtonParent}>
							<Box onClick={handleModalClose} className={classesName.backIcon}>
								<img src={leftArrow} alt="arrow back svg" />
							</Box>
							{isEditFlow ? (
								<>
									{!openInputBox ? (
										<Box style={{ display: 'contents' }}>
											<Typography
												align="left"
												className={classesName.hoverParent}
												style={{
													fontFamily: 'Bogle-Regular',
													fontSize: 18,
												}}>
												{searchText}
											</Typography>
											<Box
												className={classesName.hoverEditIcon}
												style={{
													height: '25px',
													width: '25px',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													borderRadius: '100%',
													cursor: 'pointer',
												}}>
												<ModeEditOutlineOutlinedIcon
													data-testid="edit-name-change"
													style={{
														fontSize: '18px',
													}}
													onClick={modifyInputText}
												/>
											</Box>
										</Box>
									) : (
										<TextField
											id="name"
											ref={inputRef}
											data-testid="edit-hierarchy-name-input-field"
											placeholder="Type a name here"
											type="text"
											className={classesName.textField}
											value={searchText}
											variant="outlined"
											autoFocus
											sx={{
												'& .MuiInputBase-input': {
													color: '#333',
													fontFamily: 'Bogle',
													fontSize: '16px',
													fontStyle: 'normal',
													fontWeight: 400,
													lineHeight: '24px',
												},
											}}
											onChange={(e) => {
												setSearchText(e.target.value);
											}}
											InputProps={{
												className: classesName.input,
											}}
										/>
									)}
								</>
							) : (
								<Box style={{ display: 'contents' }}>
									<Typography
										align="left"
										className={classesName.hoverParent}
										style={{
											fontFamily: 'Bogle-Regular',
											fontSize: 18,
										}}>
										Custom
									</Typography>
								</Box>
							)}
						</Box>
						{isEditFlow && errorMsg ? (
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'row',
									alignContent: 'space-between',
									width: '100%',
									alignItems: 'center',
									marginLeft: '15px',
								}}>
								<Box
									sx={{
										width: '100%',
										display: 'flex',
										color: '#cb2022',
										alignItems: 'center',
										gap: '4px',
									}}>
									<ErrorOutlineIcon sx={textStyle} />
									<Typography sx={textStyle}>{errorMsg}</Typography>
								</Box>
							</Box>
						) : (
							''
						)}
						{validateHierarchyErrorCode == 400 &&
						validateHierarchyErrorMsgCode == '101' ? (
							<Alert
								handleClose={closeValidateHierarchyErrorMsg}
								errorMsg={
									isEditFlow
										? editSavedHierarchyErrorMsg
										: validateHierarchyErrorMsg
								}
								icon={warningIcon}
								borderColor={WARNING_LIGHT}
								backgroundColor={WARNING_MIN}
								boderLeftColor={WARNING_MD}
								color={WARNING_HIGH}></Alert>
						) : (validateHierarchyErrorCode == 400 &&
								validateHierarchyErrorMsgCode == '102') ||
						  editSavedHierarchyErrorCode == 400 ? (
							<Alert
								handleClose={closeValidateHierarchyErrorMsg}
								errorMsg={
									isEditFlow
										? editSavedHierarchyErrorMsg
										: validateHierarchyErrorMsg
								}
								icon={AlertIcon}></Alert>
						) : (
							''
						)}
						<Box
							style={{
								border: '1px solid #DADCE0',
								margin: '10px 0',
								marginTop: '15px',
							}}>
							<HierarchySelectorWrapper
								hierarchyFilterRhid={hierarchyFilterRhid}
								setSelectedHierarchy={setSelectedHierarchy}
								updateHierarchySelections={updateHierarchySelections}
								hierarchySelections={hierarchySelections}
							/>
						</Box>
						<Box className={classesName.modalFooter}>
							{!isEditFlow ? (
								<FormControlLabel
									data-testid="saveHierarchy"
									className={classesName.saveThis}
									control={
										<Checkbox
											color="primary"
											onChange={(e) => checkHierarchy(e.target.checked)}
											checked={isSaveHierarchy}
										/>
									}
									label="Save this hierarchy"
								/>
							) : (
								<FormControlLabel
									control={
										<Checkbox
											color="primary"
											checked={defaultStatus}
											onChange={(e) =>
												changeSavedHierarchyDefaultStatus(e.target.checked)
											}
										/>
									}
									label="Save as Default"
								/>
							)}
							<Button
								data-testid="h-cancel-btn"
								onClick={handleModalClose}
								className={classesName.cancelBtn}>
								Cancel
							</Button>
							{!isEditFlow ? (
								<Button
									data-testid="h-apply-btn"
									onClick={handleApply}
									variant="contained"
									disabled={
										selectedHierarchy?.length == 0 || validateHierarchyLoading
									}
									sx={{
										backgroundColor: colors.PURPLE,
										'&.Mui-disabled': {
											color: colors.WHITE,
										},
									}}
									className={classesName.applyBtn}>
									Apply
								</Button>
							) : (
								<Button
									data-testid="edit-save-btn"
									onClick={handleSave}
									variant="contained"
									disabled={
										selectedHierarchy?.length == 0 ||
										errorMsg ||
										validationErrorMsg?.length > 0
									}
									sx={{
										backgroundColor: colors.PURPLE,
										'&.Mui-disabled': {
											color: colors.WHITE,
										},
									}}
									className={classesName.applyBtn}>
									Save
								</Button>
							)}
						</Box>
					</Box>
				</Modal>
				{saveHierarchyOpen && (
					<SaveHierarchyModal
						openModal={saveHierarchyOpen}
						onClose={handleOnCloseSaveHierarchy}
						onSave={handleSaveHierarchy}
						savedHierachy={savedHierachyNames}
					/>
				)}
				{saveHierarchyStatusCode !== 0 && (
					<SnackBarWrapper
						variant={saveHierarchyStatusCode > 200 ? 'error' : 'success'}
						open={isSnackBarOpen}
						hideDuration={5000}
						message={
							saveHierarchyStatusCode > 200
								? SAVE_HIERARCHY_ERROR_MESSAGE
								: saveHierarchyMessageDefault
						}
						action={action(saveHierarchyStatusCode)}
						onClose={handleSnackBarClose}
					/>
				)}
				{editSavedHierarchyErrorCode == 200 && (
					<SnackBarWrapper
						variant={'success'}
						open={editSaveSnackBarOpen}
						hideDuration={5000}
						message={HIERARCHY_APPLIED_SUCCESSFULLY}
						action={editSaveAction}
						onClose={handleEditSaveSnackBar}
					/>
				)}
			</Box>
		</ThemeProvider>
	);
}

export default BusinessHierarchy;
